(function () {
  let swiperInstance;

  const updateNavPosition = (section) => {
    const nav = section.querySelector('.featured-collections-nav');
    if (!nav) return;
    const firstSlide = section.querySelector('.featured-collections-item');
    if (!firstSlide) return;
    const imgWrapper = firstSlide.querySelector('.collection-card__img-wrapper');
    if (!imgWrapper) return;
    const swiperEl = section.querySelector('.featured-collections-layout');
    const swiperRect = swiperEl.getBoundingClientRect();
    const imgRect = imgWrapper.getBoundingClientRect();
    const offsetTop = imgRect.top - swiperRect.top;
    nav.style.top = `${offsetTop + imgRect.height / 2}px`;
  };

  const initSlider = (section) => {
    if (!section || !section.classList.contains('featured-collections-section')) return;
    const swiperEl = section.querySelector('.featured-collections-layout');
    const swiperWrapper = section.querySelector('.featured-collections-list');
    const slides = section.querySelectorAll('.featured-collections-item');
    if (!swiperEl || !swiperWrapper || !slides.length) return;
    swiperEl.classList.add('swiper');
    swiperWrapper.classList.add('swiper-wrapper');
    slides.forEach((s) => s.classList.add('swiper-slide'));
    const prevBtn = section.querySelector('.featured-collections-nav-button--prev');
    const nextBtn = section.querySelector('.featured-collections-nav-button--next');
    const columns = Number(swiperEl.dataset.columns) || 3;
    const isLoop = Boolean(swiperEl.dataset.loop);
    const breakpoints = {
      2: { 576: { slidesPerView: 2.1, spaceBetween: 20 }, 990: { slidesPerView: 2.1, spaceBetween: 24 } },
      3: { 576: { slidesPerView: 2.1, spaceBetween: 20 }, 990: { slidesPerView: 3.15, spaceBetween: 24 } },
      4: { 576: { slidesPerView: 2.1, spaceBetween: 20 }, 990: { slidesPerView: 3.15, spaceBetween: 24 }, 1360: { slidesPerView: 4.15, spaceBetween: 24 } },
    };
    swiperInstance = new Swiper(swiperEl, {
      slidesPerView: 1.15,
      spaceBetween: 16,
      speed: 800,
      allowTouchMove: true,
      loop: isLoop,
      breakpoints: breakpoints[columns] || breakpoints[3],
      mousewheel: { forceToAxis: true },
      a11y: { scrollOnFocus: false },
      preventClicks: true,
      navigation: nextBtn && prevBtn ? { nextEl: nextBtn, prevEl: prevBtn, disabledClass: 'swiper-button-disabled' } : false,
    });
    updateNavPosition(section);
    const nav = section.querySelector('.featured-collections-nav');
    if (nav) nav.classList.add('featured-collections-nav--visible');
  };

  const destroySlider = (section) => {
    if (!swiperInstance || !section) return;
    const swiperEl = section.querySelector('.featured-collections-layout');
    const swiperWrapper = section.querySelector('.featured-collections-list');
    const slides = section.querySelectorAll('.featured-collections-item');
    if (!swiperEl || !swiperWrapper || !slides.length) return;
    swiperInstance.destroy(true, true);
    swiperInstance = null;
    swiperEl.classList.remove('swiper');
    swiperWrapper.classList.remove('swiper-wrapper');
    slides.forEach((s) => s.classList.remove('swiper-slide'));
  };

  const init = (section) => {
    if (!section || !section.classList.contains('featured-collections-section')) return;
    const mainContainer = section.querySelector('.featured-collections');
    const desktopLayout = mainContainer.dataset.layout;
    const mobileLayout = mainContainer.dataset.layoutMobile;
    let currentLayout = null;
    new ResizeObserver((entries) => {
      const width = entries[0].contentRect.width;
      const newLayout = width < 576 ? mobileLayout : desktopLayout;
      if (newLayout !== currentLayout) {
        if (swiperInstance) destroySlider(section);
        if (newLayout === 'slider') initSlider(section);
        currentLayout = newLayout;
      }
      if (currentLayout === 'slider') updateNavPosition(section);
    }).observe(section);
  };

  init(document.currentScript.parentElement);
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
